"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.99996 2.5C8.51661 2.5 7.06657 2.93986 5.83321 3.76397C4.59984 4.58808 3.63856 5.75941 3.0709 7.12984C2.50325 8.50028 2.35473 10.0083 2.64411 11.4631C2.9335 12.918 3.6478 14.2543 4.69669 15.3032C5.74558 16.3521 7.08194 17.0664 8.53679 17.3558C9.99164 17.6452 11.4996 17.4967 12.8701 16.929C14.2405 16.3614 15.4118 15.4001 16.2359 14.1667C17.06 12.9333 17.4999 11.4833 17.4999 9.99995C17.4977 8.01153 16.7068 6.10519 15.3007 4.69916C13.8947 3.29314 11.9884 2.50224 9.99996 2.5ZM9.42304 6.53844C9.42304 6.38543 9.48382 6.23869 9.59201 6.13049C9.70021 6.0223 9.84695 5.96152 9.99996 5.96152C10.153 5.96152 10.2997 6.0223 10.4079 6.13049C10.5161 6.23869 10.5769 6.38543 10.5769 6.53844V10.5769C10.5769 10.7299 10.5161 10.8766 10.4079 10.9848C10.2997 11.093 10.153 11.1538 9.99996 11.1538C9.84695 11.1538 9.70021 11.093 9.59201 10.9848C9.48382 10.8766 9.42304 10.7299 9.42304 10.5769V6.53844ZM9.99996 14.0384C9.8288 14.0384 9.66149 13.9876 9.51918 13.8925C9.37687 13.7975 9.26595 13.6623 9.20045 13.5042C9.13495 13.346 9.11781 13.172 9.1512 13.0042C9.1846 12.8363 9.26701 12.6821 9.38804 12.5611C9.50907 12.4401 9.66326 12.3576 9.83113 12.3243C9.999 12.2909 10.173 12.308 10.3311 12.3735C10.4892 12.439 10.6244 12.5499 10.7195 12.6922C10.8146 12.8345 10.8653 13.0019 10.8653 13.173C10.8653 13.4025 10.7742 13.6226 10.6119 13.7849C10.4496 13.9472 10.2295 14.0384 9.99996 14.0384Z",
    fill: fill
  }));
};

exports["default"] = _default;